import template from './response.html';
import controller from './response.controller';
import './response.css';

let responseComponent = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    isOnboarding: '<',
    staffStatus: '@',
    venuesId: '<',
    eventId: '<',
    staffingUsersId: '<',
    usersId: '<',
    recapDefinitionId: '<',
    recapType: '<',
    recapResponseSetId: '<',
    recapResponse: '=?',
    recapResponsePosition: '<',
    allowExit: '<',
    allowSave: '<',
    showLanguageSelector: '<',
    previewLocationVariableIdsCommaSeparated: '@',
    previewRoleVariableId: '@',
    eventsRecapsExternalLinksViewsId: '@',
    eventsRecapsExternalLinksToken: '@',
    applicationId: '@',
    onExit: '&',
    onFinish: '&',
    onSubmitClaims: '&',
  }
};

export default responseComponent;
